export const environment = {
  production: false,
  apiBaseUrl: 'https://platform-stage-api.dataunveil.com/',
  useMockApi: false,
};
